import React, { useState } from "react";
import { ChevronLeft, Plus, Minus } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: "WHAT IS WEDDNCO?",
    answer:
      "WeddnCo is a comprehensive wedding planning platform that helps couples organize their special day. We provide tools for managing guests, vendors, timelines, and all the details that make your wedding perfect.",
  },
  {
    question: "HOW DO I RESET MY PASSWORD?",
    answer:
      'To reset your password, click on the "Forgot Password" link on the login page. Enter your email address and we\'ll send you instructions to create a new password.',
  },
  {
    question: "HOW DO I INVITE MY PLANNER?",
    answer:
      'Go to your dashboard settings, navigate to the "Team" section, and click "Invite Planner". Enter your planner\'s email address and they will receive an invitation to collaborate on your wedding.',
  },
  {
    question: "HOW DO I INVITE MY PARTNER?",
    answer:
      'Navigate to Settings > Account, and look for the "Invite Partner" option. Enter your partner\'s email address and they will receive an invitation to join your wedding planning workspace.',
  },
  {
    question: "HOW DO I TRACK RSVPS?",
    answer:
      "Access the Guest List section from your dashboard. You can view RSVP status for each guest, send reminders, and track meal preferences and plus-ones all in one place.",
  },
  {
    question: "HOW DO I SHARE OUR WEDDING PAGE?",
    answer:
      'Your wedding page has a unique URL that you can find in the "Wedding Website" section. Simply copy the link and share it with your guests via email, social media, or your invitations.',
  },
  {
    question: "HOW DO I SETUP ASO EBI?",
    answer:
      'Navigate to the "Aso Ebi" section in your dashboard. Click "Create New Aso Ebi", upload fabric designs, set prices, and generate unique order links for your guests.',
  },
  {
    question: "WHERE WILL I RECEIVE ASO EBI SALES?",
    answer:
      'All Aso Ebi sales and orders are tracked in the "Aso Ebi Sales" section of your dashboard. You\'ll receive notifications for new orders and can export the data for fulfillment.',
  },
  {
    question: "WHERE'S MY ASO EBI SALES LOG?",
    answer:
      "Your Aso Ebi sales log can be found under Dashboard > Aso Ebi > Sales Log. Here you can view all transactions, payment status, and customer details.",
  },
  {
    question: "WHO DO I CONTACT FOR HELP?",
    answer:
      "You can reach our support team at support@weddnco.com or use the live chat feature in your dashboard. We're here to help Monday through Friday, 9 AM to 6 PM.",
  },
];

const Faqs = () => {
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen w-full bg-[#F9F9F9]">
      {/* Header */}
      <div className="sticky top-0  z-10">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center">
          <button
            onClick={handleBack}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Go back"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <h1 className="text-[32px] font-[400] optima flex-1 text-center text-2xl tracking-wider pr-10">
            FAQs
          </h1>
        </div>
      </div>

      {/* FAQ List */}
      <div className="max-w-2xl mx-auto px-4 py-6">
        {faqData.map((faq, index) => (
          <div key={index} className="border-b border-gray-300">
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
              aria-expanded={expandedIndex === index}
            >
              <span className="text-sm font-normal tracking-wider pr-4">
                {faq.question}
              </span>
              {expandedIndex === index ? (
                <Minus className="w-5 h-5 flex-shrink-0" />
              ) : (
                <Plus className="w-5 h-5 flex-shrink-0" />
              )}
            </button>

            {expandedIndex === index && (
              <div className="pb-6 pr-8 text-sm text-gray-600 leading-relaxed animate-fadeIn">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;
